import React from 'react';
import About_01 from '../../../assets/images/svg/about/about-three-icon-1.svg';
import About_02 from '../../../assets/images/about/about-shape-three-1.png';
import About_03 from '../../../assets/images/about/about-shape-three-2.png';
import About_04 from '../../../assets/images/about/about-shape-three-3.png';

const About = () => {
    return (
        <>
            <div className="about-section-three">
                <div className="container">
                    <div className="about-box-outer-three">
                        <div className="row gutter-y-30">
                            <div
                                className="col-lg-4 col-md-6 about__box animate fadeInRight wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="200ms"
                            >
                                <div className="about-box-three">
                                    <div className="about-icon-three">
                                        <svg
                                            width={31}
                                            height={31}
                                            viewBox="0 0 31 31"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M1.24265 18.1436C0.61349 14.7476 1.21715 11.2386 2.94499 8.2481C4.67282 5.25762 7.41134 2.98208 10.6677 1.83105V12.7061L1.24265 18.1436Z"
                                                stroke="#56736C"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M15.5013 15.5634V1C18.0417 1.00038 20.5375 1.6682 22.7386 2.93659C24.9398 4.20498 26.7691 6.02942 28.0433 8.2272C29.3175 10.425 29.9919 12.919 29.999 15.4594C30.0062 17.9998 29.3457 20.4976 28.0838 22.7024C26.8219 24.9073 25.0029 26.742 22.8089 28.0227C20.6149 29.3034 18.1229 29.9852 15.5825 29.9998C13.0421 30.0144 10.5424 29.3613 8.33381 28.1059C6.12521 26.8505 4.28521 25.0369 2.99805 22.8467L15.5013 15.5634Z"
                                                stroke="#56736C"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                    </div>
                                    <div className="about-details-three">
                                        <h4>Growing Business</h4>
                                        <p>
                                            The current investment landscape requires a robust approach.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="col-lg-4 col-md-6 about__box animate fadeInRight wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="400ms"
                            >
                                <div className="about-box-three m-auto">
                                    <div className="about-icon-three">
                                        <svg
                                            width={36}
                                            height={36}
                                            viewBox="0 0 36 36"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M3.375 13.5H32.625L18 4.5L3.375 13.5Z"
                                                stroke="#56736C"
                                                strokeWidth="1.6875"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M7.875 13.5V24.75"
                                                stroke="#56736C"
                                                strokeWidth="1.6875"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M14.625 13.5V24.75"
                                                stroke="#56736C"
                                                strokeWidth="1.6875"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M21.375 13.5V24.75"
                                                stroke="#56736C"
                                                strokeWidth="1.6875"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M28.125 13.5V24.75"
                                                stroke="#56736C"
                                                strokeWidth="1.6875"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M4.5 24.75H31.5"
                                                stroke="#56736C"
                                                strokeWidth="1.6875"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M2.25 29.25H33.75"
                                                stroke="#56736C"
                                                strokeWidth="1.6875"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                    </div>
                                    <div className="about-details-three">
                                        <h4>Finance Investment</h4>
                                        <p>The company experiences is to empower information.</p>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="col-lg-4 col-md-6 about__box animate fadeInRight wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="600ms"
                            >
                                <div className="about-box-three ms-auto">
                                    <div className="about-icon-three">
                                        <svg
                                            width={40}
                                            height={40}
                                            viewBox="0 0 40 40"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M31 18C33.2091 18 35 16.2091 35 14C35 11.7909 33.2091 10 31 10C28.7909 10 27 11.7909 27 14C27 16.2091 28.7909 18 31 18Z"
                                                stroke="#56736C"
                                                strokeWidth="1.875"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M9 31H4.2C3.88174 31 3.57652 30.8796 3.35147 30.6653C3.12643 30.4509 3 30.1602 3 29.8571V24.1429C3 23.8398 3.12643 23.5491 3.35147 23.3347C3.57652 23.1204 3.88174 23 4.2 23H9"
                                                stroke="#56736C"
                                                strokeWidth="1.875"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M18.0435 24.4546H22.5652L32.0326 22.3532C32.3807 22.2611 32.7461 22.2478 33.1003 22.3142C33.4546 22.3806 33.7883 22.5249 34.0754 22.736C34.3624 22.9471 34.5952 23.2192 34.7556 23.5312C34.9159 23.8432 34.9996 24.1867 35 24.535C35.0002 24.9555 34.8789 25.3678 34.6498 25.7255C34.4206 26.0832 34.0927 26.3722 33.7028 26.56L28.2174 28.8182L19.1739 31H9V23.3636L12.5326 19.9546C12.8484 19.6509 13.223 19.4103 13.6352 19.2465C14.0474 19.0827 14.489 18.999 14.9348 19H22C22.7495 19 23.4684 19.2873 23.9983 19.7988C24.5283 20.3103 24.8261 21.004 24.8261 21.7273C24.8261 22.4506 24.5283 23.1443 23.9983 23.6558C23.4684 24.1672 22.7495 24.4546 22 24.4546H18.0435Z"
                                                stroke="#56736C"
                                                strokeWidth="1.875"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                d="M26.7131 13.616C25.9364 13.9831 25.062 14.0907 24.2194 13.9228C23.3768 13.7548 22.6106 13.3203 22.0342 12.6834C21.4578 12.0465 21.1017 11.2412 21.0187 10.3864C20.9357 9.53163 21.1302 8.67286 21.5733 7.93709C22.0164 7.20132 22.6847 6.62763 23.4793 6.30087C24.2739 5.97411 25.1526 5.91162 25.9855 6.12265C26.8184 6.33368 27.5612 6.80702 28.1041 7.47267C28.647 8.13832 28.9611 8.96093 29 9.81883"
                                                stroke="#56736C"
                                                strokeWidth="1.875"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                    </div>
                                    <div className="about-details-three">
                                        <h4>Tax Advisory</h4>
                                        <p>Finance helps you to convert into a strategic asset get.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-5">
                            <div
                                className="about-left-three animate fadeInLeft wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="200ms"
                            >
                                <div className="heading-box">
                                    <h2 className="heading-title">
                                        We are building great future together Be with us
                                    </h2>
                                </div>
                                <p className="lead">
                                    Crafting engaging websites to implementing powerful digital
                                    marketing strategies, we focus on understanding your unique needs
                                    and goals.
                                </p>
                                <ul className="about-list-three">
                                    <li>
                                        <span />
                                        <p>100% Better results</p>
                                    </li>
                                    <li>
                                        <span />
                                        <p>Suspe Ndisse Suscipit Sagittis</p>
                                    </li>
                                    <li>
                                        <span />
                                        <p>Promis Specific TimelineI Guarantee</p>
                                    </li>
                                    <li>
                                        <span />
                                        <p>Review Credit Reports</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-7">
                            <div
                                className="about-right-three animate fadeInRight wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="200ms"
                            >
                                <div className="about-shape-three-1">
                                    <img
                                        src={About_02}
                                        alt="shape"
                                    />
                                </div>
                                <div className="about-shape-three-2">
                                    <img
                                        src={About_03}
                                        alt="shape"
                                    />
                                </div>
                                <div className="about-shape-three-3">
                                    <div className="about-shape-image-container">
                                        <img
                                            src={About_04}
                                            alt="about-shape"
                                        />
                                    </div>
                                </div>
                                <div className="about-shape-box-three">
                                    <div className="about-shape-icon-three">
                                        <img
                                            src={About_01}
                                            alt="icon"
                                        />
                                    </div>
                                    <h4 className="counter">19201</h4>
                                    <p>Satisfied clients</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default About
